import { useUser } from '@clerk/clerk-react';

export function usePlatformAdmin() {
  const { user } = useUser();
  const isPlatformAdmin =
    (user?.publicMetadata as Record<string, unknown> | undefined)?.platformAdmin === true;
  return { isPlatformAdmin };
}
